import { Box, List, Typography } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { useMutation } from '@tanstack/react-query';
import { getMessageFromError } from '@pro4-erp/core-web';
import { FileItem, SqoFile, downloadFileFromUrl } from '@/common';
import { downloadCertificateFromDws } from '@/features/client-certificates/api/downloadFileFromCertificate';
import { checkIfErrorIsAccessAuthorizationError } from '@/core/utils/getMessageFromError';

type AnswersProps = {
  answers?: SqoFile[];
};

const Answers = ({ answers }: AnswersProps) => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const downloadFileMutation = useMutation({
    mutationFn: downloadCertificateFromDws,
    onSuccess: async () => {
      enqueueSnackbar(
        t('Successfully downloaded file.', { defaultValue: 'Successfully downloaded file.' }),
        { variant: 'success' }
      );
    },
    onError: (error: Error) => {
      checkIfErrorIsAccessAuthorizationError(error)
        ? enqueueSnackbar(
            t('No access authorisation!', { defaultValue: 'No access authorisation!' }),
            { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'center' } }
          )
        : enqueueSnackbar(getMessageFromError(error), { variant: 'error' });
    },
  });

  return (
    <Box>
      {answers && answers.length > 0 ? (
        <List>
          {answers.map((item) => (
            <FileItem
              key={item.id}
              name={item.title || ''}
              uploadedBy={item.uploadedBy}
              uploadedAt={item.uploadedAt}
              fileName={item.fileName}
              info={item.info}
              onDownload={() => {
                if (item.dwsDok)
                  downloadFileMutation.mutate({
                    dok: item.dwsDok,
                    filename: item.title || item.dwsDok.originalfilename,
                  });
              }}
            />
          ))}
        </List>
      ) : (
        <Typography variant="subtitle1">{t('No files', { defaultValue: 'No files' })}</Typography>
      )}
    </Box>
  );
};

export default Answers;
